// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__IK4uU","messages":"Chat_messages__1aVU1","dateDivider":"Chat_dateDivider__Zbiu4"};